export enum Currencies {
    None = "",
    MXN = "MXN",
    USD = "USD"
}

export enum WeightUnits {
    kg = 0,
    lb = 1
}

export enum DeliveryUnits {
    Days = 0,
    Weeks = 1,
    Months = 2
}

export enum ProductStatus {
    Current = 0,
    Obsolete = 1,    
}

export enum Units {
    Pices = "PCA",
    Package = "PKG",
    Meters = "MTS",
    Kilogram = "KG",

}